import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import common_es from "./locales/es/common.json";
import header_es from "./locales/es/header.json";
import home_es from "./locales/es/home.json";
import footer_es from "./locales/es/footer.json";
import primary_es from "./locales/es/primary.json";
import secundary_es from "./locales/es/secundary.json";
import terciary_es from "./locales/es/terciary.json";
import quaternary_es from "./locales/es/quaternary.json";
import quinary_es from "./locales/es/quinary.json";
import member_es from "./locales/es/member.json";
import positioning_es from "./locales/es/positioning.json";
import marketing_es from "./locales/es/marketing.json";
import landing_es from "./locales/es/landing.json";
import consutancy_es from "./locales/es/consultancy.json";
import help_es from "./locales/es/help.json";
import fairs_es from "./locales/es/fairs.json";
import manuals_es from "./locales/es/manuals.json";
import cases_es from "./locales/es/cases.json";
import contact_es from "./locales/es/contact.json";
import loginRegister_es from "./locales/es/loginRegister.json";
import about_es from "./locales/es/about.json";
import account_es from "./locales/es/account.json";
import userCard_es from "./locales/es/userCard.json";
import editProfile_es from "./locales/es/editProfile.json";
import userSubscriptions_es from "./locales/es/userSubscriptions.json";
import companyCard_es from "./locales/es/companyCard.json";
import companyPageEdit_es from "./locales/es/companyPageEdit.json";
import createCompanyContent_es from "./locales/es/createCompanyContent.json";
import editCompanyContent_es from "./locales/es/editCompanyContent.json";
import createCompanyPage_es from "./locales/es/createCompanyPage.json";
import messageStats_es from "./locales/es/messageStats.json";
import buying_es from "./locales/es/buying.json";
import products_es from "./locales/es/products.json";
import bussines_es from "./locales/es/bussines.json";
import faqs_es from "./locales/es/faqs.json";
import events_es from "./locales/es/events.json";
import sectors_es from "./locales/es/sectors.json";
import category_es from "./locales/es/category.json";
import subcategory_es from "./locales/es/subcategory.json";
import division_es from "./locales/es/division.json";
import adminUser_es from "./locales/es/adminUser.json";
import video_es from "./locales/es/video.json";
import slider_es from "./locales/es/slider.json";
import featured_es from "./locales/es/featured.json";
import aside_es from "./locales/es/aside.json";
import pass_es from "./locales/es/pass.json";
import affiliate_es from "./locales/es/afilliate.json";
import sellerDashboard_es from "./locales/es/sellerDashboard.json";
import createEmpresaRegional_es from "./locales/es/createEmpresaRegional.json";
import createServiceRegional_es from "./locales/es/createServiceRegional.json";
import createServices_es from "./locales/es/createServices.json";


import common_en from "./locales/en/common.json";
import header_en from "./locales/en/header.json";
import home_en from "./locales/en/home.json";
import about_en from "./locales/en/about.json";
import footer_en from "./locales/en/footer.json";
import primary_en from "./locales/en/primary.json"
import secundary_en from "./locales/en/secundary.json";
import terciary_en from "./locales/en/terciary.json";
import quaternary_en from "./locales/en/quaternary.json";
import quinary_en from "./locales/en/quinary.json";
import member_en from "./locales/en/member.json";
import positioning_en from "./locales/en/positioning.json";
import marketing_en from "./locales/en/marketing.json";
import landing_en from "./locales/en/landing.json";
import consutancy_en from "./locales/en/consultancy.json";
import help_en from "./locales/en/help.json";
import fairs_en from "./locales/en/fairs.json";
import manuals_en from "./locales/en/manuals.json";
import cases_en from "./locales/en/cases.json";
import contact_en from "./locales/en/contact.json";
import loginRegister_en from "./locales/en/loginRegister.json";
import account_en from "./locales/en/account.json";
import userCard_en from "./locales/en/userCard.json";
import editProfile_en from "./locales/en/editProfile.json";
import userSubscriptions_en from "./locales/en/userSubscriptions.json";
import companyCard_en from "./locales/en/companyCard.json";
import companyPageEdit_en from "./locales/en/companyPageEdit.json";
import createCompanyContent_en from "./locales/en/createCompanyContent.json";
import editCompanyContent_en from "./locales/en/editCompanyContent.json";
import createCompanyPage_en from "./locales/en/createCompanyPage.json";
import messageStats_en from "./locales/en/messageStats.json";
import buying_en from "./locales/en/buying.json";
import products_en from "./locales/en/products.json";
import bussines_en from "./locales/en/bussines.json";
import faqs_en from "./locales/en/faqs.json";
import events_en from "./locales/en/events.json";
import sectors_en from "./locales/en/sectors.json";
import category_en from "./locales/en/category.json";
import subcategory_en from "./locales/en/subcategory.json";
import division_en from "./locales/en/division.json";
import adminUser_en from "./locales/en/adminUser.json";
import video_en from "./locales/en/video.json";
import slider_en from "./locales/en/slider.json";
import featured_en from "./locales/en/featured.json";
import aside_en from "./locales/en/aside.json";
import pass_en from "./locales/en/pass.json";
import affiliate_en from "./locales/en/afilliate.json";
import sellerDashboard_en from "./locales/en/sellerDashboard.json";
import createEmpresaRegional_en from "./locales/en/createEmpresaRegional.json";
import createServiceRegional_en from "./locales/en/createServiceRegional.json";
import createServices_en from "./locales/en/createServices.json";

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  resources: {
    es: {
      common: common_es,
      home: home_es,
      about: about_es,
      header: header_es,
      footer: footer_es,
      primary: primary_es,
      secundary: secundary_es,
        terciary: terciary_es,
        quaternary: quaternary_es,
        quinary: quinary_es,
        member: member_es,
        positioning: positioning_es,
        marketing: marketing_es,
        landing: landing_es,
        consutancy: consutancy_es,
        help: help_es,
        fair: fairs_es,
        manual: manuals_es,
        cases: cases_es,
        contact: contact_es,
        loginRegister: loginRegister_es,
        about: about_es,
        account: account_es,
        userCard: userCard_es,
        editProfile: editProfile_es,
        userSubscriptions: userSubscriptions_es,
        companyCard: companyCard_es,
        companyPageEdit: companyPageEdit_es,
        createCompanyContent: createCompanyContent_es,
        editCompanyContent: editCompanyContent_es,
        createCompanyPage: createCompanyPage_es,
        messageStats: messageStats_es,
        buying: buying_es,
        products: products_es,
        bussines: bussines_es,
        faqs: faqs_es,
        events: events_es,
        sectors: sectors_es,
        category: category_es,
        subcategory: subcategory_es,
        division: division_es,
        adminUser: adminUser_es,
        video: video_es,
        slider: slider_es,
        featured: featured_es,
        aside: aside_es,
        pass: pass_es,
        affiliate: affiliate_es,
        sellerDashboard: sellerDashboard_es,
        createEmpresaRegional:createEmpresaRegional_es,
        createServiceRegional:createServiceRegional_es,
        createServices:createServices_es
      },
      en: {
        common: common_en,
        home: home_en,
        about: about_en,
        header: header_en,
        footer: footer_en,
        primary: primary_en,
        secundary: secundary_en,
        terciary: terciary_en,
        quaternary: quaternary_en,
        quinary: quinary_en,
        member: member_en,
        positioning: positioning_en,
        marketing: marketing_en,
        landing: landing_en,
        consutancy: consutancy_en,
        help: help_en,
        fair: fairs_en,
        manual: manuals_en,
        cases: cases_en,
        contact: contact_en,
        loginRegister: loginRegister_en,
        about: about_en,
        account: account_en,
        userCard: userCard_en,
        editProfile: editProfile_en,
        userSubscriptions: userSubscriptions_en,
        companyCard: companyCard_en,
        companyPageEdit: companyPageEdit_en,
        createCompanyContent: createCompanyContent_en,
        editCompanyContent: editCompanyContent_en,
        createCompanyPage: createCompanyPage_en,
        messageStats: messageStats_en,
        buying: buying_en,
        products: products_en,
        bussines: bussines_en,
        faqs: faqs_en,
        events: events_en,
        sectors: sectors_en,
        category: category_en,
        subcategory: subcategory_en,
        division: division_en,
        adminUser: adminUser_en,
        video: video_en,
        slider: slider_en,
        featured: featured_en,
        aside: aside_en,
        pass: pass_en,
        affiliate: affiliate_en,
        sellerDashboard: sellerDashboard_en,
        createEmpresaRegional:createEmpresaRegional_en,
        createServiceRegional:createServiceRegional_en,
        createServices:createServices_en
      }
    },
    fallbackLng: "en",
    ns: ["common", "header", "home", "about", "footer", "primary", "secundary", "terciary", "quaternary", "quinary", "member", "positioning", "marketing", "landing", "consutancy", "help", "fair", "manual", "cases", "contact", "loginRegister", "account", "userCard", "editProfile", "userSubscriptions", "companyCard", "companyPageEdit", "createCompanyContent", "editCompanyContent", "createCompanyPage", "messageStats", "buying", "aside", "pass", "affiliate", "sellerDashboard","createEmpresaRegional","createServiceRegional","createServices"], // nombres de namespaces
    defaultNS: "common",
    interpolation: {
      escapeValue: false
    }
  });
  
export default i18n;
